/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import footerConfig from "../config/footer.config.json";
import settingsConfig from "../config/settings.config.json";
import loadingConfig from "../config/loading.config.json";
import emptyConfig from "../config/empty.config.json";
import errorConfig from "../config/error.config.json";
import profileCardConfig from "../config/profileCard.config.json";
import rolesConfig from "../config/roles.config.json";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      profileCardConfig: profileCardConfig,
      header: { refreshButton: headerConfig?.refreshButton || {} },
      ...(headerConfig || {}),
      ...(footerConfig || {}),
      settingsConfig: settingsConfig,
      loading: loadingConfig,
      empty: emptyConfig || {},
      error: errorConfig,
      roles: rolesConfig?.roles,
    };
  }
}
